import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';


var
	CLASS_ACTIVE = 'is-active',
	SELECTOR_ITEM = '.prices-item',
	SELECTOR_LINK = '.packages .link'
;


class View extends BaseView {

	render() {
		super.render();

		// There are two types of filters: select or input
		this.$select = this.$el.find('select:first');
		if (this.$select.length) {
			this._setActive(this.$select);
		} else {
			this._setActive(this.$el.find('input:checked'));
		}

		return this;
	}

	events() {
		return {
			'change input': this._onChange,
			'change select': this._onChange
		};
	}

	_setActive($el) {
		const active = $el.val();

		// Show active price item
		this.$el.find(SELECTOR_ITEM).removeClass(CLASS_ACTIVE)
			.filter('[data-id="' + active + '"]').addClass(CLASS_ACTIVE);

		// Change selected option
		if (this.$select.length) {
			this.$el.find('option').prop('selected', false)
				.filter('[value="' + active + '"]').prop('selected', true);
		} else {
			this.$el.find('input:checked').prop('checked', false);
			$el.prop('checked', true);
		}

		// Update active value as link parameter
		this.$el.find(SELECTOR_LINK).each((index, el) => {
			const $link = $(el);

			$link.attr('href', this._setLinkParams($link.attr('href'), {
				packagetype: $link.closest('[data-type]').data('type'),
				adlimit: active
			}));
		});
	}

	_setLinkParams(url, obj) {
		var str = url || '';

		Object.keys(obj).forEach(function(key) {
			var query = str.replace(new RegExp('([?&]+)(' + key + '[^&]*&+)'), '$1');

			str = query + (query.indexOf('?') !== -1 ? '&' : '?') + key + '=' + obj[key];
		});

		return str;
	}

	_onChange({currentTarget}) {
		this._setActive($(currentTarget));
	}

}

export default View;
